import { render, staticRenderFns } from "./MotpCertn.vue?vue&type=template&id=090cf525&scoped=true"
import script from "./MotpCertn.vue?vue&type=script&lang=js"
export * from "./MotpCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090cf525",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090cf525')) {
      api.createRecord('090cf525', component.options)
    } else {
      api.reload('090cf525', component.options)
    }
    module.hot.accept("./MotpCertn.vue?vue&type=template&id=090cf525&scoped=true", function () {
      api.rerender('090cf525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/MotpCertn.vue"
export default component.exports